import axiosDefault from 'axios';

import { getConfigVar } from './config.utils';

const axios = axiosDefault.create({
    baseURL: getConfigVar('REACT_APP_API_URL') as string,
    headers: {
        'Content-Type': 'application/json',
    },
});

axios.interceptors.request.use((config) => {
    const apiKey = getConfigVar('REACT_APP_API_KEY');

    if (apiKey) {
        config.headers = config.headers ?? {};
        config.headers['X-API-Key'] = apiKey as string;
    }

    return config;
});

export { axios };

export type { AxiosResponse } from 'axios';
